// REMIX HMR BEGIN
if (!window.$RefreshReg$ || !window.$RefreshSig$ || !window.$RefreshRuntime$) {
  console.warn('remix:hmr: React Fast Refresh only works when the Remix compiler is running in development mode.');
} else {
  var prevRefreshReg = window.$RefreshReg$;
  var prevRefreshSig = window.$RefreshSig$;
  window.$RefreshReg$ = (type, id) => {
    window.$RefreshRuntime$.register(type, "\"app\\\\components\\\\pages\\\\book-studio\\\\CrewSection\\\\CrewSection.tsx\"" + id);
  }
  window.$RefreshSig$ = window.$RefreshRuntime$.createSignatureFunctionForTransform;
}
var _s = $RefreshSig$();
import * as __hmr__ from "remix:hmr";
if (import.meta) {
  import.meta.hot = __hmr__.createHotContext(
  //@ts-expect-error
  "app\\components\\pages\\book-studio\\CrewSection\\CrewSection.tsx");
  import.meta.hot.lastModified = "1757171103291.8179";
}
// REMIX HMR END

import { useState } from "react";
import { PersonCard } from "~/components/shared/PeopleSection/components/PersonCard";
import { PeopleToolbar } from "~/components/shared/PeopleSection/components/PeopleToolbar";
export function CrewSection({
  data
}) {
  _s();
  const [filters, setFilters] = useState({
    location: "",
    role: ""
  });
  const filteredPeople = data.people.filter(person => {
    const locationMatch = !filters.location || person.location === filters.location;
    const roleMatch = !filters.role || person.role === filters.role;
    return locationMatch && roleMatch;
  });
  const handleFilterChange = newFilters => {
    setFilters(newFilters);
  };
  return <div className="mt-8 space-y-8">
      <h2 className="text-heading-3 !text-neutral-900">{data.title}</h2>

      {/* Toolbar - Responsive */}
      <div className="mb-4">
        <div className="lg:block">
          <PeopleToolbar filters={filters} filterOptions={data.filterOptions} onChange={handleFilterChange} />
        </div>
      </div>

      {/* People Grid */}
      <div className="grid grid-cols-2 lg:grid-cols-4 gap-3 lg:gap-6">
        {filteredPeople.map(person => <PersonCard key={person.id} {...person} />)}
      </div>
    </div>;
}
_s(CrewSection, "/v35BBMitIxRI0se5qejbFE/baw=");
_c = CrewSection;
var _c;
$RefreshReg$(_c, "CrewSection");

window.$RefreshReg$ = prevRefreshReg;
window.$RefreshSig$ = prevRefreshSig;